import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import logo from "../assets/hospitalimg.png";

const Training = () => {
  const insuranceCompanies = [
    "National Insurance",
    "MD India Health",
    "Bharti AXA GIC",
    "Cholamandalam MS GIC",
    "Future Generali India",
    "The New India",
    "ICICI Lombard GIC",
    "IFFCO Tokio GIC",
    "Kotak Mahindra GIC",
    "Liberty GIC",
    "The Oriental",
    "Manipal Cigna HIC",
    "Niva Bupa",
    "HDFC ERGO GIC",
    "United Health Care Prekh",
    "Health India",
    "TATA AIG GIC",
    "Magma HDI GIC",
    "Medi Assist",
    "Aditya Birla HIC",
    "Vidal Health",
    "Universal Sompo GIC",
    "Star Health & Allied",
    "Ericson TPA",
    "Vipul Medcorp",
    "ACKO General",
    "Family Health Plan",
    "Health Insurance TPA",
    "Heritage",
    "Alankit",
    "Raksha Health",
    "Park Mediclaim",
    "Navi GIC",
    "Safeway",
    "SBI GIC",
    "Good Health",
    "Medsave Health",
    "Go Digit",
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <img
          src={logo}
          alt="Insurance Tie-Up"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-sky-900/90 to-blue-900/70"></div>

        <div className="relative z-10 text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-bold text-white mb-4"
          >
            Insurance <span className="text-sky-300">Tie-Up</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-white/90 max-w-3xl mx-auto"
          >
            Cashless & reimbursement facilities available with leading insurance
            companies and TPAs
          </motion.p>
        </div>
      </section>

      {/* Overview */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 text-center max-w-4xl">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-6 text-gray-800"
          >
            Trusted Insurance <span className="text-sky-500">Partners</span>
          </motion.h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Ashoka Hospital has tie-ups with multiple insurance companies and TPAs
            to ensure smooth cashless hospitalization and hassle-free claim
            processing for our patients.
          </p>
        </div>
      </section>

      {/* Insurance List */}
      <section className="py-20 bg-gradient-to-b from-sky-50 to-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {insuranceCompanies.map((company, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.03 }}
              >
                <Card className="border-none shadow-lg hover:shadow-2xl transition-all h-full bg-white">
                  <CardContent className="p-6 flex items-center gap-4">
                    <div className="w-12 h-12 bg-sky-500/10 rounded-xl flex items-center justify-center">
                      <ShieldCheck className="w-6 h-6 text-sky-600" />
                    </div>
                    <p className="font-semibold text-gray-800 text-sm leading-snug">
                      {company}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Government Schemes */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-3xl p-12 text-white text-center shadow-2xl"
          >
            <h2 className="text-4xl font-bold mb-4">
              Government & Institutional Schemes
            </h2>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">
              Yeshasvini · Ayushman Bharat – Arogya Karnataka · Dharmasthala ·
              KSRTC · HESCOM
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Training;
